
import Vue from "vue";
// @ts-ignore
import Autocomplete from "@trevoreyre/autocomplete-vue";
// import "@trevoreyre/autocomplete-vue/dist/style.css";
import {Line, Result, SeriesData, ServerData, ServerMessage} from "@/interfaces";
import {BAlert, BIcon, BIconPlayFill} from "bootstrap-vue";
// @ts-ignore
import VueYoutube from "vue-youtube";
import debounce from "lodash-es/debounce";
import {Location} from "vue-router";
import {baseURL} from "@/utils";
import SeriesSelector from "@/components/SeriesSelector.vue";
import Intro from "@/components/Intro.vue";

Vue.use(VueYoutube);


export default Vue.extend({
  name: "home",
  components: {
    Intro,
    SeriesSelector,
    Autocomplete,
    BAlert,
    BIcon,
    BIconPlayFill,
  },
  data() {
    return {
      serverData: {series: []} as ServerData,
      searchResult: [] as Result[],
      episode: this.$route.params.episode,
      error: undefined as ServerMessage | undefined,
      ytOptIn: false,
      showYtOptIn: false,
      ytVideoID: undefined as string | undefined,
      showYT: false,
      YTright: true,
      ytResult: undefined as Result | undefined,
      ytWidth: 640,
      showSeriesSelector: false,
      placeholderText: "",
      placeholderFullText: "",
      placeholderTimeout: 0,
      placeholderInterval: 0
    };
  },
  created() {
    fetch(baseURL + "series")
      .then((response) => response.json())
      .then((data: ServerData) => {
        this.serverData = data;
      });
    this.placeholderTimeout = setTimeout(this.startTyping, 7 * 1000);
  },
  beforeDestroy() {
    clearTimeout(this.placeholderTimeout);
  },
  mounted(): void {
    if (localStorage.getItem("ytOptIn") !== null) {
      this.ytOptIn = localStorage.getItem("ytOptIn") === "true";
    }
    if (this.episode == null) {
      this.episode = "10";
    }
    document.title = "CR Search";
    if (this.$route.params.keyword) {
      this.search();
    }
    const max = 640;
    this.ytWidth = (window.innerWidth < max ? window.innerWidth : max) - 2 * 2;
  },
  methods: {
    suggest(input: string) {
      const url = baseURL
        + "suggest?query=" + input
        + "&until=" + this.episode
        + "&series=" + this.$route.params.series;

      return new Promise((resolve) => {
        if (input.length < 1) {
          return resolve([]);
        }
        fetch(url)
          .then((response) => response.json())
          .then((data: string[]) => {
            resolve(data);
          });
      });
    },
    handleSubmit(result: string) {
      // @ts-ignore
      const newKeyword = result || this.$refs.searchInput.value;
      if (newKeyword === "" && this.placeholderFullText) {
        // @ts-ignore
        this.$refs.searchInput.value = this.placeholderFullText;
        this.handleSubmit(this.placeholderFullText);
        return;
      }
      this.$router.push({params: {...this.$route.params, keyword: newKeyword}});

    },
    search(): void {
      if (!this.$route.params.keyword) {
        return;
      }
      const url = baseURL
        + "search?query=" + this.$route.params.keyword
        + "&until=" + this.episode
        + "&series=" + this.$route.params.series;
      document.title = this.$route.params.keyword + " | CR Search";

      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            this.error = data;
            this.searchResult = [];
          } else {
            this.error = undefined;
            this.searchResult = data;
          }
        });
    },
    expand(result: Result) {
      const offset = result.offset ? result.offset : 1;
      const url = baseURL + "expand?centerID=" + result.centerID + "&offset=" + offset;

      fetch(url)
        .then((response) => response.json())
        .then((data: Line[]) => {

          this.searchResult[result.resultID].lines.push(...data);
          this.searchResult[result.resultID].lines.sort((a, b) => a.order - b.order);
          this.searchResult[result.resultID].offset = offset + 1;
        });

    },
    firstLine(result: Result): Line {
      return result.lines[0];
    },
    episodeName(line: Line): string {
      if (line.episode.series.is_campaign) {
        return `Episode ${line.episode.episode_number}: ${line.episode.pretty_title}`;
      }
      return line.episode.pretty_title;
    },
    formatTimestamp(ts: number) {
      return new Date(ts).toISOString().substr(11, 8);
    },
    getColor(line: Line): string {
      if (line.ismeta) {
        return "pink";
      } else if (line.isnote) {
        return "purple";
      }
      if (line.person) {
        return line.person.color;
      }
      return "white";
    },
    doYtOptIn() {
      this.showYtOptIn = false;
      this.ytOptIn = true;
      this.playVideo(undefined);
    },
    playVideo(result: Result | undefined): void {
      if (!this.ytOptIn) {
        this.ytResult = result;
        this.showYtOptIn = true;
        return;
      }
      if (!result && this.ytResult) {
        result = this.ytResult;
      }
      if (!result) {
        return;
      }
      const firstLine = this.firstLine(result);
      const newYtVideoID = firstLine.episode.youtube_id;
      if (!this.$refs.youtube) {
        this.showYT = true;
        this.ytResult = result;
      } else {
        // @ts-ignore
        const player = this.$refs.youtube.player;
        if (firstLine) {
          if (this.ytVideoID === newYtVideoID) {
            player.seekTo(firstLine.starttime / 1000);
          } else {
            player.loadVideoById(
              newYtVideoID,
              firstLine.starttime / 1000,
              firstLine.endtime / 1000
            );
            this.ytVideoID = newYtVideoID;
          }
        }
      }
    },
    closeVideo(): void {
      this.showYT = false;
      this.ytVideoID = undefined;
      this.ytResult = undefined;
    },
    startTyping(): void {
      // @ts-ignore
      if (this.$refs.searchInput.value !== "") {
        this.placeholderTimeout = setTimeout(this.startTyping, 5000);
        return;
      }
      const url = baseURL
        + "suggestion"
        + "?until=" + this.episode
        + "&series=" + this.$route.params.series;

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error();
          }
          return response.text();
        })
        .then((data) => {
          this.placeholderFullText = data;
          clearTimeout(this.placeholderTimeout);
          this.placeholderText = "";
          this.typing(0);
        })
        .catch((error) => {
          this.placeholderTimeout = setTimeout(this.startTyping, 5000);
        });

    },
    typing(index: number): void {
      if (index === this.placeholderFullText.length) {
        this.placeholderTimeout = setTimeout(this.untype, 5000);
        return;
      }
      this.placeholderText += this.placeholderFullText[index];
      const offset = Math.random() * 80 - 40;
      this.placeholderTimeout = setTimeout(this.typing, 70 + offset, index + 1);
    },
    untype(): void {
      if (this.placeholderText.length === 0) {
        this.placeholderTimeout = setTimeout(this.startTyping, 5000);
        return;
      }
      this.placeholderText = this.placeholderText.slice(0, -1);
      const offset = Math.random() * 40 - 20;
      this.placeholderTimeout = setTimeout(this.untype, 35 + offset);
    },
    transcriptLink(result: Result): Location {
      const firstline = this.firstLine(result);
      const episode = firstline.episode;
      return {
        name: "transcript",
        params: {
          episodeNr: episode.episode_number.toString(),
          series: episode.series.slug
        },
        hash: "#" + firstline.starttime
      };
    }
  },
  computed: {
    ytLink(): string {
      if (!this.ytResult) {
        return "";
      }
      const firstline = this.firstLine(this.ytResult);
      const starttime = firstline.starttime / 1000;
      const id = firstline.episode.youtube_id;
      const min = Math.floor(starttime / 60);
      const sec = Math.floor(starttime % 60);
      return `https://www.youtube.com/watch?v=${id}&t=${min}m${sec}s`;
    },
    seriesFromSlug(): SeriesData | undefined {
      if (!this.$route.params.series) {
        return undefined;
      }
      return this.serverData.series.find((series) => {
        return series.slug === this.$route.params.series;
      });
    },
    seriesTitle(): string {
      const series = this.seriesFromSlug;
      if (series) {
        return series.title;
      } else {
        return this.$route.params.series;
      }
    },
    seriesLength(): number {
      const series = this.seriesFromSlug;
      if (series) {
        return series.length;
      }
      return 300;
    },
    isOneShot(): boolean {
      return this.episode === "-";
    }
  },
  watch: {
    episode: debounce(function(val: number): void {
      // @ts-ignore
      this.$router.push({params: {...this.$route.params, episode: val}});
    }, 300),
    "$route.params.keyword"(val: string): void {
      // @ts-ignore
      this.$refs.searchInput.value = this.$route.params.keyword;
    },
    "$route.params"(val) {
      // this.series = this.$route.params.series;
      this.showSeriesSelector = false;
      this.search();
    },
    ytOptIn(value: boolean): void {
      localStorage.setItem("ytOptIn", value.toString());
    },
  },
});
